import React from 'react'
import Icon from '../Display/Icon'

export default (props) => {
	if (props.user) {
		return (
			<div className='capps-navbar-tab right' onTouchTap={() => props.redux.auth.logoutUser()}>
				<div className='capps-navbar-icon'>
					<Icon name='logout-variant' color='dark' />
					log out
				</div>
			</div>
		)
	}
	return (
		<div className='capps-navbar-tab right' onTouchTap={() => props.redux.nav.addPage('login')}>
			<div className='capps-navbar-icon'>
				<Icon name='login-variant' color='dark' />
				log in
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/Components/Nav/SigninOutButton.js